import { ProjectTemplateLink } from "@Projects/Model";

export interface ICommand { }


export class ExportProjectCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Projects.Commands.ExportProjectCommandV1, TCh.Domain.Projects';

	Id: string;

	constructor(id: string) {
		this.Id = id;
	}

	static matchType(cmd: any) {
		return cmd.$type == 'TCh.Domain.Projects.Commands.ExportProjectCommandV1, TCh.Domain.Projects'
	}

}

export class UpdateProjectCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.UpdateProjectCommandV1, TCh.Domain.Projects';

	Id: string;
	WorkspaceId: number;
	Name: string;
	Description: string;

	constructor(workspaceId: number, projectId: number, name: string, description: string)
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.UpdateProjectCommandV1, TCh.Domain.Projects'
	}
}

export class DeleteProjectCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.DeleteProjectCommandV1, TCh.Domain.Projects';

	Id: string;
	WorkspaceId: number;

	constructor(workspaceId: number, projectId: number)
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.DeleteProjectCommandV1, TCh.Domain.Projects'
	}
}

export class CloneProjectCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.CloneProjectCommandV1, TCh.Domain.Projects';

	Id: string;
	WorkspaceId: number;
	CloneName: string;

	constructor(workspaceId: number, sourceProjectId: number, cloneName: string)
	{
		this.Id = sourceProjectId.toString();
		this.WorkspaceId = workspaceId;
		this.CloneName = cloneName;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.CloneProjectCommandV1, TCh.Domain.Projects'
	}
}

export class DownloadProjectTemplateCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.DownloadProjectTemplateCommandV1, TCh.Domain.Projects';
	
	WorkspaceId: number;
	Id: string;
	ProjectTemplateLinkId: number;

	constructor(workspaceId: number, sourceProjectId: number, sourceProjectTemplateLinkId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = sourceProjectId.toString();
		this.ProjectTemplateLinkId = sourceProjectTemplateLinkId;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.DownloadProjectTemplateCommandV1, TCh.Domain.Projects'
	}
}



export class CreatePortfolioProjectCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.CreatePortfolioProjectCommandV1, TCh.Domain.Projects';

	Id: string;
	WorkspaceId: number;
	Name: string;
	Description: string;

	constructor(workspaceId: number, name: string, description: string)
	{
		this.Id = "0";
		this.WorkspaceId = workspaceId;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.CreatePortfolioProjectCommandV1, TCh.Domain.Projects'
	}
}

export class CreateDecisionProjectCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.CreateDecisionProjectCommandV1, TCh.Domain.Projects';

	Id: string;
	WorkspaceId: number;
	Name: string;
	Description: string;

	constructor(workspaceId: number, name: string, description: string)
	{
		this.Id = "0";
		this.WorkspaceId = workspaceId;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.CreateDecisionProjectCommandV1, TCh.Domain.Projects'
	}
}



export class UpdateProjectTemplateLinksCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.UpdateProjectTemplateLinksCommandV1, TCh.Domain.Projects';

	Id: string;
	WorkspaceId: number;
	Links: ProjectTemplateLink[];

	constructor(workspaceId: number, projectId: number, links: ProjectTemplateLink[])
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.Links = links;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.UpdateProjectTemplateLinksCommandV1, TCh.Domain.Projects'
	}
}

export class SwitchProjectWorkspaceCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.SwitchProjectWorkspaceCommandV1, TCh.Domain.Projects';

	Id: string;
	SourceWorkspaceId: number;
	TargetWorkspaceId: number;

	constructor(sourceWorkspaceId: number, projectId: number, targetWorkspaceId: number)
	{
		this.Id = projectId.toString();
		this.SourceWorkspaceId = sourceWorkspaceId;
		this.TargetWorkspaceId = targetWorkspaceId;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.SwitchProjectWorkspaceCommandV1, TCh.Domain.Projects'
	}
}



export class CreateProjectUsersTagCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.CreateProjectUsersTagCommandV1, TCh.Domain.Projects';

	Id: string;
	WorkspaceId: number;
	Tag: string;

	constructor(workspaceId: number, projectId: number, tag: string)
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.Tag = tag;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.CreateProjectUsersTagCommandV1, TCh.Domain.Projects'
	}
}

export class DeleteProjectUsersTagCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.DeleteProjectUsersTagCommandV1, TCh.Domain.Projects';

	Id: string;
	WorkspaceId: number;
	Tag: string;

	constructor(workspaceId: number, projectId: number, tag: string)
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.Tag = tag;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.DeleteProjectUsersTagCommandV1, TCh.Domain.Projects'
	}
}

export class UpdateProjectUsersTagCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.Projects.Commands.UpdateProjectUsersTagCommandV1, TCh.Domain.Projects';

	Id: string;
	WorkspaceId: number;
	OldTag: string;
	NewTag: string;

	constructor(workspaceId: number, projectId: number, oldTag: string, newTag: string)
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.OldTag = oldTag;
		this.NewTag = newTag;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.Projects.Commands.UpdateProjectUsersTagCommandV1, TCh.Domain.Projects'
	}
}




